import { render, staticRenderFns } from "./modal-box.vue?vue&type=template&id=5436df0d&"
import script from "./modal-box.vue?vue&type=script&lang=js&"
export * from "./modal-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports